import { DomainGroup } from "@/models";
import { list, listAll } from "@/utils/factoryRest";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";
import { DomainGroupApi } from "@socotec.io/certipers-back-sdk";
import configs from "@/setup/openApiConfig";

const domainGroupApi = new DomainGroupApi(configs.certipersBackConfig);
const domainGroupRepo = useRepo(DomainGroup);

export const useDomainGroupStore = defineStore("domainGroup", {
  state: () => ({
    domainGroupsCount: 0,
  }),

  actions: {
    async fetchAllDomainGroups(filters = {}) {
      const response = await listAll(domainGroupApi.list.bind(domainGroupApi), filters);
      this.setDomainGroupsCount(response.length);
      return domainGroupRepo.save(response);
    },

    fetchDomainGroups: list({
      ModelRepo: domainGroupRepo,
      restListMethod: domainGroupApi.list.bind(domainGroupApi),
      onItemsInserted: ({ count }) => {
        useDomainGroupStore().setDomainGroupsCount(count);
      },
    }),

    setDomainGroupsCount(count) {
      this.domainGroupsCount = count;
    },
  },

  getters: {
    getDomainGroupsCount: (state) => state.domainGroupsCount,
  },
});
